import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { products as baseProducts } from '../mock';
import { api } from '../lib/api';

const CatalogueContext = createContext({
  products: baseProducts,
  settings: {
    announcement: 'Rajpurohit Perfumes',
    freeShippingMin: 599,
    sampleGiftMin: 2499,
  },
  refresh: () => {},
});

function applyOverrides(list, overrides) {
  return list
    .map((p) => {
      const ov = overrides[p.id] || {};
      return {
        ...p,
        price: Number(ov.price) > 0 ? Number(ov.price) : p.price,
        mrp: Number(ov.mrp) > 0 ? Number(ov.mrp) : p.mrp,
        badge: ov.badge !== undefined ? ov.badge : p.badge,
        active: ov.active === false ? false : true,
        stock: Number.isFinite(Number(ov.stock)) && ov.stock !== '' && ov.stock != null
          ? Math.max(0, Math.floor(Number(ov.stock)))
          : null,
      };
    })
    .filter((p) => p.active !== false);
}

export function CatalogueProvider({ children }) {
  const [overrides, setOverrides] = useState({});
  const [settings, setSettings] = useState({
    announcement: 'Rajpurohit Perfumes',
    freeShippingMin: 599,
    sampleGiftMin: 2499,
  });

  const refresh = () =>
    api('/storefront')
      .then((d) => {
        setOverrides(d.overrides || {});
        setSettings({
          announcement: d.settings?.announcement || 'Rajpurohit Perfumes',
          freeShippingMin: Number(d.settings?.freeShippingMin) || 599,
          sampleGiftMin: Number(d.settings?.sampleGiftMin) || 2499,
        });
      })
      .catch(() => {});

  useEffect(() => {
    refresh();
  }, []);

  const products = useMemo(() => applyOverrides(baseProducts, overrides), [overrides]);

  const value = useMemo(
    () => ({ products, settings, overrides, refresh }),
    [products, settings, overrides]
  );

  return <CatalogueContext.Provider value={value}>{children}</CatalogueContext.Provider>;
}

export function useCatalogue() {
  return useContext(CatalogueContext);
}
